var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsertCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_8001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 21.6667V7.5C13.5156 6.83696 13.7801 6.20107 14.2508 5.73223C14.7215 5.26339 15.36 5 16.0257 5C16.6914 5 17.3298 5.26339 17.8005 5.73223C18.2713 6.20107 18.5357 6.83696 18.5357 7.5V20",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5312 19.1654V15.832C18.5313 15.169 18.7957 14.5331 19.2664 14.0643C19.7371 13.5954 20.3756 13.332 21.0413 13.332C21.707 13.332 22.3454 13.5954 22.8162 14.0643C23.2869 14.5331 23.5513 15.169 23.5513 15.832V19.9987",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5547 17.5C23.5547 16.837 23.8191 16.2011 24.2899 15.7322C24.7606 15.2634 25.399 15 26.0647 15C26.7304 15 27.3689 15.2634 27.8396 15.7322C28.3103 16.2011 28.5748 16.837 28.5748 17.5V20",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5705 19.168C28.5705 18.5049 28.8349 17.869 29.3056 17.4002C29.7764 16.9314 30.4148 16.668 31.0805 16.668C31.7462 16.668 32.3846 16.9314 32.8554 17.4002C33.3261 17.869 33.5905 18.5049 33.5905 19.168V26.668C33.5905 29.3201 32.5327 31.8637 30.6499 33.739C28.767 35.6144 26.2132 36.668 23.5504 36.668H20.2037H20.5517C18.889 36.6682 17.2522 36.2572 15.7883 35.4718C14.3244 34.6863 13.0794 33.5511 12.1648 32.168L11.8369 31.668C11.3148 30.8696 9.48245 27.688 6.3382 22.1213C6.01767 21.5539 5.93205 20.8842 6.09955 20.2549C6.26705 19.6255 6.67446 19.0861 7.23512 18.7513C7.83231 18.3944 8.5321 18.2465 9.22334 18.331C9.91459 18.4156 10.5576 18.7278 11.0504 19.218L13.5102 21.668",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48586 4.9987L6.8125 3.33203",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8218 11.668H5.14844",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5547 4.9987L25.228 3.33203",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2266 10H26.8999",
    stroke: "#4DABCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_8001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.1606,
    height: 40,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertCall);
export default __webpack_public_path__ + "static/media/insert-call.35aa9d286d533b615da83f2d1ae39e59.svg";
export { ForwardRef as ReactComponent };